import React, { useEffect, useState } from "react";
import { getDashBoardData } from "../../apis/dashboard";
import DashBoardCard from "./SubComponents/DashBoardCard/DashBoardCard";
import Popup from "../../ReusableFunctions/Popup";
import {
  addCommasToAmount,
  addLeadingZero,
  formatAmountWithSymbol,
  getDSPId,
  reduceLongName,
} from "../../ReusableFunctions/reusableFunctions";
import Orders from "./SubComponents/Graphs/Orders";
import ResourceUtilization from "./SubComponents/Graphs/ResourceUtilization";
import { ROUTES } from "../../routes";
import TotalRequestStatus from "../../Components/TotalRequestStatus";
import RecentRequests from "../../Components/RecentRequests";
import joyStickCardIcon from "../../assets/joyStickCardIcon.svg";
import droneCardIcon from "../../assets/droneCardIcon.svg";
import customersCardIcon from "../../assets/customersCardIcon.svg";
import teamsCardIcon from "../../assets/teamsCardIcon.svg";
import locationCardIcon from "../../assets/locationCardIcon.svg";
import serviceCardIcon from "../../assets/serviceIcon.svg";
import joyStickCardIconActive from "../../assets/joyStickCardIconActive.svg";
import droneCardIconActive from "../../assets/droneCardIconActive.svg";
import customersCardIconActive from "../../assets/customersCardIconActive.svg";
import teamsCardIconActive from "../../assets/teamsCardIconActive.svg";
import locationCardIconActive from "../../assets/locationCardIconActive.svg";
import serviceCardIconActive from "../../assets/serviceHover.svg";
import arrowGrp from "../../assets/arrowGrp.svg";
import thickBar1 from "../../assets/thickBar1.svg";
import DashboardMainCard from "../../ReusableComponents/DashboardMainCard";
import dateFormat from "dateformat";
import { STATUS } from "../../appConstants";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

const HomePage = () => {
  const user = useSelector((state) => state.user.user);
  const [dashBoardData, setDashBoardData] = useState([]);
  const [dashboardDataLoading, setDashBoardDataLoading] = useState(true);
  const { pathname } = useLocation();
  let requestsStats = {
    [STATUS.PLACED]: 0,
    [STATUS.ACCEPTED]: 0,
    [STATUS.RESCHEDULED]: 0,
    [STATUS.OUT_FOR_SERVICE]: 0,
    [STATUS.INPROGRESS]: 0,
    [STATUS.COMPLETED]: 0,
    [STATUS.PAID]: 0,
    [STATUS.CANCELLED]: 0,
    total: 0,
  };

  const [showAlert, setShowAlert] = useState(false);
  const [remainingDays, setRemainingDays] = useState(null);

  function getDaysLeft(startTime, endTime, currentTime = new Date()) {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const current = new Date(currentTime);

    const startDate = new Date(
      start.getFullYear(),
      start.getMonth(),
      start.getDate(),
    );
    const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    const currentDate = new Date(
      current.getFullYear(),
      current.getMonth(),
      current.getDate(),
    );

    if (currentDate > endDate) return "Subscription expired";

    const totalDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
    const daysPassed = Math.floor(
      (currentDate - startDate) / (1000 * 60 * 60 * 24),
    );
    let daysLeft = totalDays - daysPassed;
    // if (daysLeft < 1) daysLeft = 1;
    if (daysLeft <= 0) {
      const diffMs = end - current;
      if (diffMs <= 0) return "Subscription expired";

      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      return `${daysLeft} Days ${diffHours} Hours ${diffMinutes} Minutes `;
    }

    return `${daysLeft}`;
  }

  const notify = () => {
    const subscription = user.subscription;
    if (!subscription || !subscription.end_date) return;
    const daysLefts = getDaysLeft(
      new Date(subscription.start_date),
      new Date(subscription.end_date),
      new Date(),
    );

    if (subscription.type?.toLowerCase() === "trial") {
      setRemainingDays(`${daysLefts}`);
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };

  const getDashBoardDataAPI = () => {
    setDashBoardDataLoading(true);

    getDashBoardData()
      .then((res) => {
        setDashBoardData(res);
        setDashBoardDataLoading(false);
      })
      .catch((err) => {
        Popup.alert("Error", err, "ERROR");
        setDashBoardDataLoading(false);
      });
  };

  useEffect(() => {
    document.title = "BhuMeet - HomePage";
    const dsp_id = getDSPId();
    if (dsp_id !== "admin") {
      getDashBoardDataAPI();
    }
    notify();
  }, []);

  const clearLocalStorageOfRequests = () => {
    localStorage.removeItem("requestFilters");
    localStorage.removeItem("currentRequestPage");
    localStorage.removeItem("fromDateTime");
    localStorage.removeItem("dspDebitNotesFilters");
    localStorage.removeItem("dspInvoicesFilters");
    localStorage.removeItem("isCalenderView");
    localStorage.removeItem("userPageFilters");
    localStorage.removeItem("currentUserPage");
    localStorage.removeItem("isCalenderView");
    localStorage.removeItem("filterDateTime");
    localStorage.removeItem("dspCustomersPage");
    localStorage.removeItem("salesStoresFilters");
    localStorage.removeItem("adminStoresFilters");
    localStorage.removeItem("request_filters_status");
    localStorage.removeItem("currentCalenderDate");
  };

  useEffect(() => {
    if (pathname === "/") {
      clearLocalStorageOfRequests();
    }
  }, [pathname]);

  return (
    <>
      <div className="dashBoardWrapper">
        {showAlert && (
          <div
            id="alert-1"
            class="flex items-center p-4 mb-4 rounded-lg bg-[#C75A00] text-white"
            role="alert"
          >
            <div class="ms-3 text-sm">
              {/* <span className="font-bold">{remainingDays} {remainingDays <= 1 ? "day" : "days"} </span> left out of your 15-days trial , upgrade continue. */}
              {typeof remainingDays === "string" &&
              remainingDays.includes(" Hours") ? (
                <>
                  <span className="font-bold">{remainingDays}</span> left out of
                  your 15-day trial, upgrade to continue.
                </>
              ) : (
                <>
                  <span className="font-bold">
                    {remainingDays} {remainingDays <= 1 ? "day" : "days"}
                  </span>{" "}
                  left out of your 15-day trial, upgrade to continue.
                </>
              )}
            </div>
            <div className="ms-auto flex items-center gap-4">
              <button
                onClick={() => {
                  window.location.href = "/plan-purchase";
                }}
                className="inline-flex bg-white text-[#C75A00] px-3 py-1 rounded items-center justify-center"
              >
                Upgrade
              </button>
              <button
                type="button"
                class="-mx-1.5 -my-1.5 text-white-900 p-1.5 inline-flex items-center justify-center h-8 w-8"
                data-dismiss-target="#alert-1"
                aria-label="Close"
                onClick={() => setShowAlert(false)}
              >
                <span class="sr-only">Close</span>
                <svg
                  class="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}

        <div className="dashboard-heading">
          <div className="dashboard-company-name">
            {reduceLongName(user?.dsp?.name, 20)}
          </div>
          <div className="dashboard-wellcome-text">
            {user && user.name
              ? `Hi, ${reduceLongName(user?.dsp?.name, 20)} Welcome back!`
              : ""}
          </div>
        </div>

        {/*----- 1st section ----------*/}
        <div className="dashboard-first-section">
          <div className="dashboard-first-section-first-div">
            <div style={{ width: "50%", position: "releative" }}>
              <DashboardMainCard
                view={ROUTES.REVENUE}
                height="100%"
                loading={dashboardDataLoading}
                title="Revenue"
                // mainData={<div>{dashBoardData && dashBoardData.totalRevenue ? formatAmountWithSymbol(dashBoardData?.totalRevenue, user?.country_code) : '00'}</div>}
                mainData={
                  <div>
                    {dashBoardData && dashBoardData.totalRevenue
                      ? formatAmountWithSymbol(
                          dashBoardData?.totalRevenue,
                          user?.country_code,
                          user?.dsp?.invoice_currency,
                        )
                      : "00"}
                  </div>
                }
                subData={`Till ${dateFormat(new Date(), "dd mmmm yyyy")}`}
                animatedElement={<img className="card-arrow" src={arrowGrp} />}
                graphData={dashBoardData.lastSevenDaysRevenueGraphData}
              />
            </div>
            <div style={{ width: "50%", position: "releative" }}>
              <DashboardMainCard
                view={ROUTES.MYREQUESTS}
                loading={dashboardDataLoading}
                height="100%"
                title="Requests"
                mainData={
                  <div>
                    {dashBoardData && dashBoardData.totalRequestCount
                      ? addCommasToAmount(dashBoardData.totalRequestCount)
                      : "00"}
                  </div>
                }
                subData={`Till ${dateFormat(new Date(), "dd mmmm yyyy")}`}
                animatedElement={
                  <img
                    className="card-arrow"
                    style={{ paddingLeft: "5px" }}
                    src={thickBar1}
                  />
                }
                graphData={dashBoardData.lastSevenDaysRequestGraphData}
              />
            </div>
          </div>

          <div className="dashboard-first-section-second-div">
            <div className="dashboard-first-section-second-div-one">
              <DashBoardCard
                loading={dashboardDataLoading}
                view={ROUTES.DRONE_PILOTS}
                title="Pilots"
                data={
                  dashBoardData && dashBoardData.pilots
                    ? addLeadingZero(dashBoardData.pilots)
                    : "00"
                }
                icon={joyStickCardIcon}
                hoverIcon={joyStickCardIconActive}
              />
              <DashBoardCard
                loading={dashboardDataLoading}
                view={ROUTES.MYDRONE}
                title="Drones"
                data={
                  dashBoardData && dashBoardData.drones
                    ? addLeadingZero(dashBoardData.drones)
                    : "00"
                }
                icon={droneCardIcon}
                hoverIcon={droneCardIconActive}
              />
              <DashBoardCard
                isDisabled={user.location_id ? true : false}
                loading={dashboardDataLoading}
                view={ROUTES.CUSTOMERS}
                title="Customers"
                data={
                  dashBoardData && dashBoardData.users
                    ? addLeadingZero(dashBoardData.users)
                    : "00"
                }
                icon={customersCardIcon}
                hoverIcon={customersCardIconActive}
              />
            </div>
            <div className="dashboard-first-section-second-div-two">
              <DashBoardCard
                loading={dashboardDataLoading}
                view={ROUTES.MYSERVICES}
                title="Total Services"
                data={
                  dashBoardData && dashBoardData.services
                    ? addLeadingZero(dashBoardData.services)
                    : "00"
                }
                icon={serviceCardIcon}
                hoverIcon={serviceCardIconActive}
              />
              <DashBoardCard
                loading={dashboardDataLoading}
                view={"manageLocations"}
                title="Locations"
                data={
                  dashBoardData && dashBoardData.locations
                    ? addLeadingZero(dashBoardData.locations)
                    : "00"
                }
                icon={locationCardIcon}
                hoverIcon={locationCardIconActive}
              />
              <DashBoardCard
                loading={dashboardDataLoading}
                view={ROUTES.MANAGE_TEAM}
                title="My Team"
                data={
                  dashBoardData && dashBoardData.totalTeamMembers
                    ? addLeadingZero(dashBoardData.totalTeamMembers)
                    : "00"
                }
                icon={teamsCardIcon}
                hoverIcon={teamsCardIconActive}
                isDisabled={!user?.is_admin}
              />
            </div>
          </div>
        </div>
        {/*------ 1st section End -----*/}

        {/* ----- 2nd section --------- */}
        <div className="dashboard-second-section">
          <div className="dashboard-second-section-first-div">
            <div style={{ height: "100%", width: "100%" }}>
              <div className="dashboard-cards-heading">
                Total Request Status
              </div>
              {
                <div
                  style={{
                    height: "88%",
                    marginTop: "21px",
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <TotalRequestStatus
                    isLoading={dashboardDataLoading}
                    totalRequestCount={dashBoardData.totalRequestCount}
                    requestStatusData={{
                      ...requestsStats,
                      ...dashBoardData.statusWiseRequestsCount,
                    }}
                  />
                </div>
              }
            </div>
          </div>
          <div
            style={{ width: "50%", borderRadius: "5px", background: "white" }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "",
                height: "100%",
                justifyContent: "start",
              }}
            >
              <Orders showAll filter width="100%" />
              {/* <ResourceUtilization /> */}
            </div>
          </div>
        </div>
        {/* ----- 2nd section End--------- */}

        {/* ----- 3rd section --------- */}
        <div className="dashboard-third-section">
          <div
            style={{
              width: "50%",
              borderRadius: "7px",
              background: "white",
              height: "100%",
            }}
          >
            <RecentRequests user={user} />
          </div>
          <div
            style={{ width: "50%", background: "white", borderRadius: "7px" }}
          >
            <div style={{ width: "100%", height: "100%" }}>
              <ResourceUtilization width={"100%"} />
            </div>
          </div>
        </div>
        {/* ----- 3rd section end --------- */}
      </div>
    </>
  );
};

export default HomePage;
